import { auth, db } from './firebase'; // Adjust based on your Firebase setup
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { setDoc, doc, getDoc } from 'firebase/firestore';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

export const registerUser = async (email, password, name) => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Create user document in Firestore
    await setDoc(doc(db, 'users', user.uid), {
        email: user.email,
        name: name,
        isGoogleUser: false, // Set this field to false for Email/Password users
        // Add other fields as necessary
    });
};

export const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    console.log('Google User:', user); // Debug log

    // Create or update user document in Firestore
    await setDoc(doc(db, 'users', user.uid), {
        email: user.email,
        name: user.displayName,
        isGoogleUser: true, // Set this field to true for Google users
        // Add other fields as necessary
    }, { merge: true });
};

export const loginUser = async (email, password) => {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Check if user document exists
    const userDocRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userDocRef);

    // If the user document does not exist, create it
    if (!userDoc.exists()) {
        await setDoc(userDocRef, {
            email: user.email,
            name: '', // You can set a default name or leave it empty
            isGoogleUser: false,
        });
    }
}; 